// extracted by mini-css-extract-plugin
module.exports = {"table":"tableSeo_table__SaZ0j","th":"tableSeo_th__PIGuE","td":"tableSeo_td__p8PN5","tr":"tableSeo_tr__4AF7X"};